import {
  RECENT_PROJECT_DETAILS_BY_ID_LOADING,
  RECENT_PROJECT_DETAILS_BY_ID_SUCCESS,
  RECENT_PROJECT_DETAILS_BY_ID_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listSingleItemService } from "services/listSingleItemService";
import { campaignListUrl } from "api/apiUrls";

export const recentProjectDetailsActions =
  (id: any) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: RECENT_PROJECT_DETAILS_BY_ID_LOADING, payload: true });
      const response = await listSingleItemService(
        `${campaignListUrl}`,
        `?id=${id}`
      );

      dispatch({
        type: RECENT_PROJECT_DETAILS_BY_ID_SUCCESS,
        payload: response.data,
      });
    } catch (err) {
      dispatch({ type: RECENT_PROJECT_DETAILS_BY_ID_FAILURE, payload: err });
    } finally {
      dispatch({ type: RECENT_PROJECT_DETAILS_BY_ID_LOADING, payload: false });
    }
  };
